import { http } from 'services';

export type LearnerReferralStatus = 'pending' | 'rewarded' | 'reversed';

export interface LearnerReferralLink {
  code: string;
  link: string;
  /** Off in admin: no card is shown and new signups are not captured. */
  enabled: boolean;
  referrerBonusSom: number;
  referredBonusSom: number;
}

export interface LearnerReferralItem {
  id: string;
  friendName: string;
  status: LearnerReferralStatus;
  bonusSom: number;
  createdAt?: string;
  rewardedAt?: string;
}

export interface LearnerReferralList {
  items: LearnerReferralItem[];
  invited: number;
  rewarded: number;
  earnedSom: number;
}

export async function getLearnerReferralLink(signal: AbortSignal): Promise<LearnerReferralLink> {
  const { data } = await http.request.get<LearnerReferralLink>('/api/portal/referrals/link', { signal });
  return data;
}

export async function getLearnerReferrals(signal: AbortSignal): Promise<LearnerReferralList> {
  const { data } = await http.request.get<LearnerReferralList>('/api/portal/referrals', { signal });
  return data;
}
